// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/an9IG6IiQiCnRAsELfCDWg

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

const Image = props => {
	const { t, itemActiveIndex: activeIndex, unsavedChanges } = props;
	const { language } = props
	const images = props.componentData.slice(0,4).map((image, index) => {
		const imageDataWithChanges = {
			...image,
			...(activeIndex === index ? unsavedChanges : {})
		};
		const {
			id,
			conversions,
			position,
			size,
			scale,
			tag,
			imageLanguage,
			tagAlternateText,
		} = imageDataWithChanges;
		let translate = '';

		// Translate image position if scale !== 1
		if (scale !== 1) {
			const x = (((100 * scale)-100) / 2) * (((50-position[0]) / 100) * 2);
			const y = (((100 * scale)-100) / 2) * (((50-position[1]) / 100) * 2);
			translate = `translate(${x}%, ${y}%) `;
		}

		const styles = {
			backgroundImage: `url(${props.lowres ? conversions.min : conversions.large})`,
			backgroundPosition: `${position[0]}% ${position[1]}%`,
			backgroundSize: `${size}`,
			transform: `${translate}scale(${scale})`,
			imageRendering: '-webkit-optimize-contrast'
		};

		// Hide image if imageLanguage
		// New feature which is not true on old brochures
		if ( typeof imageLanguage !== 'undefined' && imageLanguage !== false && imageLanguage !== language ) {
			return
		}

		const tagText = (typeof tagAlternateText !== 'undefined' && tagAlternateText[language])
			? tagAlternateText[language] : t('illustration')

		return (
			<div key={id} className="b-image-wrap">
				<div style={styles} className="b-image-source" />
				{
					tag &&
					<div className="b-image-tag">{tagText}</div>
				}
			</div>
		)
	}).filter( Boolean )


	// const imageCount = Math.min(4, props.componentData.length); // PDF brochure can only show 4 images
	const imageCount = Math.min(4, images.length); // PDF brochure can only show 4 images
	const className = `b-component b-image b-${imageCount}-images b-image-layout-${props.options.layout}`;

	return (
		<div className={className}>
			{images}
		</div>
	)

}

Image.propTypes = {
	t: PropTypes.func,
	componentData: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string,
		conversions: PropTypes.shape({
			large: PropTypes.string,
			medium: PropTypes.string,
			small: PropTypes.string,
			min: PropTypes.string,
			xs: PropTypes.string,
		}),
		position: PropTypes.arrayOf(PropTypes.number),
		size: PropTypes.oneOf(['cover', 'contain']),
		scale: PropTypes.number,
		tag: PropTypes.any,
		imageLanguage: PropTypes.oneOf([false, 'fi', 'en']),
		tagAlternateText: PropTypes.string,
	})),
	unsavedChanges: PropTypes.object,
	itemActiveIndex: PropTypes.number,
	options: PropTypes.shape({
		layout: PropTypes.string,
	}),
	lowres: PropTypes.bool,
}

export default translate('translations')(Image);
